<div class="container">
    <div class="card">
        <div class="itensI">
            <mat-icon class="icon">lock</mat-icon>
        </div>
        
        <div class="itens">
           <span>Não autorizado</span>
           <button mat-raised-button class="btn" (click)="irParaHome()">Voltar</button>
        </div>
    </div>

</div>